import { render, staticRenderFns } from "./MenuMinhaConta.vue?vue&type=template&id=e15d81bc"
import script from "./MenuMinhaConta.vue?vue&type=script&lang=ts"
export * from "./MenuMinhaConta.vue?vue&type=script&lang=ts"
import style0 from "./MenuMinhaConta.vue?vue&type=style&index=0&id=e15d81bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports